"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NUMBER_MAX_LENGTH = exports.MAX_PAGE_SIZE_SEARCH_ITEMS = exports.MAX_FILE_SIZE = exports.LONG_FIELD_LENGTH = exports.SHORT_FIELD_LENGTH = exports.SUBJECT_MAX_LENGTH = void 0;
exports.SUBJECT_MAX_LENGTH = 900;
exports.SHORT_FIELD_LENGTH = 256;
exports.LONG_FIELD_LENGTH = 65000;
exports.MAX_FILE_SIZE = 1073741824 * 2; // 2GB
exports.MAX_PAGE_SIZE_SEARCH_ITEMS = 100;
exports.NUMBER_MAX_LENGTH = 12;
//# sourceMappingURL=constants.js.map